import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import { FormattedMessage } from 'react-intl';
import { SbRespTradeOnApprovalPromoLocationFilter } from './SbRespTradeOnApprovalPromoLocationFilter';

import style from './SbRespTradeOnApprovalPromoBanner.scss';

export function SbRespTradeOnApprovalPromoBannerComponent(props) {
    const { searchBrowse } = props;
    return (
        <div className={style.container}>
            <div className={style.leftCol}>
                <div className={style.headerContainer}>
                    <div className={style.header}>
                        <FormattedMessage
                            id="abt.SbRespTradeOnApprovalPromoBanner.header"
                            defaultMessage="Find Local Items On Approval"
                        />
                    </div>
                    <div className={style.subheader}>
                        <FormattedMessage
                            id="abt.SbRespTradeOnApprovalPromoBanner.subheader"
                            defaultMessage="Tip: Minimize shipping costs by searching for items in a nearby city or state."
                        />
                    </div>
                </div>
                <SbRespTradeOnApprovalPromoLocationFilter searchBrowse={searchBrowse} />
            </div>
            <div className={style.rightCol} />
        </div>
    );
}

SbRespTradeOnApprovalPromoBannerComponent.propTypes = {
    searchBrowse: PropTypes.object,
};

export const SbRespTradeOnApprovalPromoBanner = createFragmentContainer(
    SbRespTradeOnApprovalPromoBannerComponent,
    {
        searchBrowse: graphql`
            fragment SbRespTradeOnApprovalPromoBanner_searchBrowse on SearchBrowseQueryConnection {
                ...SbRespTradeOnApprovalPromoLocationFilter_searchBrowse
            }
        `,
    }
);
